import React, { useState } from 'react';
import './Diagnosis.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000';
// ── Field wajib diisi (sesuai foto) ───────────────────────────────────────────
const REQUIRED_FIELDS = [
  'age_months',          // Usia Anak
  'temperature',         // Suhu Tubuh
  'fever_before',        // Didahului Demam  (bool — wajib dipilih secara sadar)
  'duration_minutes',    // Durasi Kejang
  'focal_movement',      // Gerakan Fokal    (bool)
  'recurrence_same_day', // Berulang 24 Jam  (bool)
  'loss_of_consciousness',// Hilang Kesadaran (bool)
];

// Kunci field yang merupakan boolean dan wajib (harus pernah ditekan)
const REQUIRED_BOOL_FIELDS = ['fever_before','focal_movement','recurrence_same_day','loss_of_consciousness'];



// ── 8 Kelompok Fitur (total 100) ──────────────────────────────────────────────
const GROUPS = [
  {
    id: 'A', title: 'Demografis & Riwayat', icon: '👤', color: '#38bdf8',
    fields: [
      { key:'age_months',              label:'Usia Anak (bulan)',                type:'number', min:1,  max:120, step:1,   default:24,  unit:'bulan' },
      { key:'sex_male',                label:'Jenis Kelamin Laki-laki',          type:'bool' },
      { key:'birth_weight_kg',         label:'Berat Lahir',                      type:'number', min:1.0,max:5.0, step:0.1, default:3.2, unit:'kg' },
      { key:'gestational_age_weeks',   label:'Usia Gestasi',                     type:'number', min:24, max:42,  step:1,   default:39,  unit:'minggu' },
      { key:'premature_birth',         label:'Lahir Prematur (<37 minggu)',      type:'bool' },
      { key:'neonatal_complications',  label:'Ada Komplikasi Neonatal',          type:'bool' },
      { key:'breastfed_months',        label:'Lama ASI Eksklusif',              type:'number', min:0,  max:12,  step:1,   default:6,   unit:'bulan' },
      { key:'prev_febrile_seizure',    label:'Pernah Kejang Demam Sebelumnya',  type:'bool' },
      { key:'n_prior_seizures',        label:'Jumlah Kejang Sebelumnya',        type:'number', min:0,  max:20,  step:1,   default:0,   unit:'kali' },
      { key:'age_first_seizure_months',label:'Usia Saat Kejang Pertama',        type:'number', min:0,  max:120, step:1,   default:24,  unit:'bulan' },
      { key:'vaccination_status',      label:'Imunisasi Lengkap',               type:'bool' },
      { key:'post_vaccination_seizure',label:'Kejang Pasca Vaksinasi',          type:'bool' },
      { key:'developmental_milestone', label:'Keterlambatan Perkembangan (0=Normal,1=Ringan,2=Berat)', type:'number', min:0, max:2, step:1, default:0, unit:'' },
      { key:'socioeconomic_score',     label:'Skor Ekonomi Keluarga (1–5)',     type:'number', min:1,  max:5,   step:1,   default:3,   unit:'' },
      { key:'parental_anxiety_score',  label:'Skor Kecemasan Orang Tua (1–10)',type:'number', min:1,  max:10,  step:1,   default:5,   unit:'' },
    ],
  },
  {
    id: 'B', title: 'Pengukuran Saat Kejang', icon: '📊', color: '#a78bfa',
    fields: [
      { key:'temperature',             label:'Suhu Tubuh Saat Kejang',          type:'number', min:35.0,max:42.0,step:0.1, default:37.0,unit:'°C' },
      { key:'heart_rate_bpm',          label:'Denyut Jantung',                  type:'number', min:60,  max:220, step:1,   default:120, unit:'bpm' },
      { key:'respiratory_rate',        label:'Frekuensi Napas',                 type:'number', min:10,  max:70,  step:1,   default:28,  unit:'/menit' },
      { key:'oxygen_saturation',       label:'Saturasi Oksigen (SpO2)',         type:'number', min:70,  max:100, step:0.1, default:98.0,unit:'%' },
      { key:'blood_pressure_systolic', label:'Tekanan Darah Sistolik',          type:'number', min:50,  max:160, step:1,   default:95,  unit:'mmHg' },
      { key:'blood_pressure_diastolic',label:'Tekanan Darah Diastolik',         type:'number', min:30,  max:110, step:1,   default:60,  unit:'mmHg' },
      { key:'blood_glucose_mmol',      label:'Gula Darah',                      type:'number', min:1.0, max:15.0,step:0.1, default:4.8, unit:'mmol/L' },
      { key:'sodium_meq',              label:'Natrium Serum',                   type:'number', min:120, max:155, step:0.1, default:137, unit:'mEq/L' },
      { key:'potassium_meq',           label:'Kalium Serum',                    type:'number', min:2.5, max:7.0, step:0.1, default:4.0, unit:'mEq/L' },
      { key:'calcium_mg',              label:'Kalsium Total',                   type:'number', min:6.0, max:13.0,step:0.1, default:9.5, unit:'mg/dL' },
    ],
  },
  {
    id: 'C', title: 'Karakteristik Kejang', icon: '⚡', color: '#f87171',
    fields: [
      { key:'fever_before',            label:'Didahului Demam Sebelum Kejang',  type:'bool' },
      { key:'fever_duration_h',        label:'Lama Demam Sebelum Kejang',       type:'number', min:0,   max:72,  step:0.5, default:0,   unit:'jam' },
      { key:'fever_max_temp',          label:'Suhu Puncak Demam',              type:'number', min:35.0,max:42.0,step:0.1, default:37.0,unit:'°C' },
      { key:'duration_minutes',        label:'Durasi Kejang',                   type:'number', min:0.5, max:120, step:0.5, default:3,   unit:'menit' },
      { key:'onset_type',              label:'Awitan Fokal (1=Fokal,0=Umum)',  type:'number', min:0,   max:1,   step:1,   default:0,   unit:'' },
      { key:'focal_movement',          label:'Gerakan Fokal Satu Sisi Tubuh',  type:'bool' },
      { key:'recurrence_same_day',     label:'Berulang dalam 24 Jam Sama',     type:'bool' },
      { key:'nocturnal_onset',         label:'Kejang Saat Tidur Malam',        type:'bool' },
      { key:'prodromal_symptoms',      label:'Ada Gejala Prodromal/Aura',      type:'bool' },
      { key:'ictal_cry',               label:'Ada Teriakan Ictal Saat Awal',   type:'bool' },
      { key:'tonic_phase',             label:'Ada Fase Tonik (Kekakuan)',       type:'bool' },
      { key:'clonic_phase',            label:'Ada Fase Klonik (Sentakan)',      type:'bool' },
      { key:'tonic_clonic',            label:'Tonik-Klonik Bilateral',          type:'bool' },
      { key:'myoclonic_jerks',         label:'Mioklonik (Sentakan Singkat)',    type:'bool' },
      { key:'atonic_episode',          label:'Episode Atonik (Jatuh Mendadak)',type:'bool' },
      { key:'absence_stare',           label:'Tatapan Kosong (Absans)',         type:'bool' },
      { key:'automatisms',             label:'Automatisme (Ngunyah, Tepuk)',    type:'bool' },
      { key:'versive_head',            label:'Deviasi Kepala ke Satu Sisi',     type:'bool' },
      { key:'bilateral_symmetric',     label:'Gerakan Bilateral Simetris',     type:'bool' },
      { key:'prolonged_30min',         label:'Durasi >30 Menit (Status)',       type:'bool' },
    ],
  },
  {
    id: 'D', title: 'Gejala Ikutan Perikejang', icon: '🩺', color: '#fbbf24',
    fields: [
      { key:'loss_of_consciousness',   label:'Hilang Kesadaran Penuh',          type:'bool' },
      { key:'eye_deviation',           label:'Deviasi Mata ke Satu Arah',       type:'bool' },
      { key:'eye_rolling_up',          label:'Mata Mendelik ke Atas',           type:'bool' },
      { key:'cyanosis',                label:'Sianosis (Bibir/Kulit Biru)',      type:'bool' },
      { key:'urinary_incontinence',    label:'Inkontinensia Urin',              type:'bool' },
      { key:'fecal_incontinence',      label:'Inkontinensia Feses',             type:'bool' },
      { key:'tongue_bite',             label:'Lidah Tergigit',                  type:'bool' },
      { key:'excessive_salivation',    label:'Hipersalivasi Berlebih',          type:'bool' },
      { key:'vomiting_ictal',          label:'Muntah Saat/Setelah Kejang',      type:'bool' },
      { key:'postictal_drowsy',        label:'Mengantuk/Lemas Pasca Kejang',    type:'bool' },
      { key:'postictal_confusion',     label:'Bingung Pasca Kejang',            type:'bool' },
      { key:'postictal_weakness',      label:'Kelemahan Fokal Pasca Kejang',    type:'bool' },
      { key:'postictal_aphasia',       label:'Gangguan Bicara Pasca Kejang',    type:'bool' },
      { key:'postictal_duration_min',  label:'Lama Periode Pasca Kejang',       type:'number', min:0, max:300, step:1, default:10, unit:'menit' },
      { key:'headache_post',           label:'Nyeri Kepala Pasca Kejang',       type:'bool' },
    ],
  },
  {
    id: 'E', title: 'Riwayat Medis & Keluarga', icon: '👨‍👩‍👧', color: '#4ade80',
    fields: [
      { key:'family_history_seizure',  label:'Riwayat Keluarga Kejang/Epilepsi',type:'bool' },
      { key:'family_history_epilepsy', label:'Riwayat Keluarga Epilepsi (Diagnosis)',type:'bool' },
      { key:'parent_febrile_seizure',  label:'Orang Tua Pernah Kejang Demam',  type:'bool' },
      { key:'sibling_febrile_seizure', label:'Saudara Kandung Pernah Kejang Demam',type:'bool' },
      { key:'family_epilepsy_degree',  label:'Derajat Kekerabatan Epilepsi (1=Orang Tua,2=Kakek,3=Sepupu)',type:'number', min:0,max:3,step:1,default:0,unit:'' },
      { key:'prior_epilepsy_diagnosis',label:'Sudah Diagnosis Epilepsi Sebelumnya',type:'bool' },
      { key:'antiepileptic_drug_use',  label:'Sedang Konsumsi Obat Anti-Epilepsi',type:'bool' },
      { key:'prior_eeg_abnormal',      label:'EEG Sebelumnya Abnormal',         type:'bool' },
      { key:'prior_mri_abnormal',      label:'MRI Kepala Sebelumnya Abnormal',  type:'bool' },
      { key:'meningitis_history',      label:'Riwayat Meningitis/Ensefalitis', type:'bool' },
      { key:'head_trauma_history',     label:'Riwayat Trauma Kepala',           type:'bool' },
      { key:'cerebral_palsy',          label:'Diagnosis Cerebral Palsy',        type:'bool' },
      { key:'intellectual_disability', label:'Disabilitas Intelektual',         type:'bool' },
      { key:'autism_spectrum',         label:'Gangguan Spektrum Autisme',       type:'bool' },
      { key:'chromosomal_disorder',    label:'Kelainan Kromosom Diketahui',     type:'bool' },
    ],
  },
  {
    id: 'F', title: 'Kondisi Penyerta', icon: '🦠', color: '#22d3ee',
    fields: [
      { key:'upper_resp_infection',    label:'Infeksi Saluran Napas Atas',      type:'bool' },
      { key:'otitis_media',            label:'Otitis Media (Infeksi Telinga)',  type:'bool' },
      { key:'gastroenteritis',         label:'Gastroenteritis (Diare/Muntah)', type:'bool' },
      { key:'roseola_herpesv6',        label:'Roseola / HHV-6',                type:'bool' },
      { key:'influenza',               label:'Influenza Terkonfirmasi',         type:'bool' },
      { key:'covid_associated',        label:'Terkait COVID-19',                type:'bool' },
      { key:'urinary_tract_infection', label:'Infeksi Saluran Kemih',           type:'bool' },
      { key:'pneumonia',               label:'Pneumonia',                       type:'bool' },
      { key:'dengue_fever',            label:'Demam Dengue',                    type:'bool' },
      { key:'anemia',                  label:'Anemia (Hb < 11 g/dL)',           type:'bool' },
    ],
  },
  {
    id: 'G', title: 'Lingkungan & Sosial', icon: '🏠', color: '#fb923c',
    fields: [
      { key:'urban_residence',         label:'Tinggal di Perkotaan',            type:'bool' },
      { key:'distance_hospital_km',    label:'Jarak ke RS Terdekat',            type:'number', min:0, max:200, step:1, default:15, unit:'km' },
      { key:'prior_er_visit',          label:'Pernah ke IGD Karena Kejang',     type:'bool' },
      { key:'caregiver_knowledge',     label:'Pengetahuan Pengasuh (1=Rendah,2=Sedang,3=Tinggi)',type:'number', min:1,max:3,step:1,default:2,unit:'' },
      { key:'seizure_first_aid_given', label:'Pertolongan Pertama Diberikan',   type:'bool' },
      { key:'diazepam_available',      label:'Diazepam Rektal Tersedia di Rumah',type:'bool' },
      { key:'time_to_er_min',          label:'Waktu dari Kejang ke IGD',        type:'number', min:0, max:360, step:5, default:40, unit:'menit' },
      { key:'home_alone_during',       label:'Anak Sendirian Saat Kejang',      type:'bool' },
    ],
  },
  {
    id: 'H', title: 'Pemeriksaan Neurologis', icon: '🧠', color: '#e879f9',
    fields: [
      { key:'gcs_score',               label:'GCS Score',                       type:'number', min:3, max:15, step:1, default:15, unit:'' },
      { key:'pupil_reflex_normal',     label:'Refleks Pupil Normal',            type:'bool' },
      { key:'meningeal_signs',         label:'Ada Tanda Meningisme',            type:'bool' },
      { key:'focal_neuro_deficit',     label:'Ada Defisit Neurologis Fokal',    type:'bool' },
      { key:'fontanelle_bulging',      label:'Ubun-ubun Menonjol (Bayi)',       type:'bool' },
      { key:'deep_tendon_reflex',      label:'Refleks Tendon Dalam (0=Normal,1=Hiperaktif,2=Hiporeaktif)',type:'number', min:0,max:2,step:1,default:0,unit:'' },
      { key:'coordination_normal',     label:'Koordinasi Normal',               type:'bool' },
    ],
  },
];

// Build default values
// Required bool fields start as null (belum dipilih), bool biasa start 0
const buildDefaults = () => {
  const d = {};
  GROUPS.forEach(g => g.fields.forEach(f => {
    if (f.type === 'bool') {
      d[f.key] = REQUIRED_BOOL_FIELDS.includes(f.key) ? null : 0;
    } else {
      d[f.key] = f.default ?? 0;
    }
  }));
  return d;
};

export default function Diagnosis({ go }) {
  const [vals, setVals]         = useState(buildDefaults());
  const [activeGroup, setActive]= useState('A');
  const [loading, setLoading]   = useState(false);
  const [pdfLoading, setPdfLoad]= useState(false);
  const [error, setError]       = useState('');
  const [touched, setTouched]   = useState({});  // track which bool fields have been explicitly toggled
  const [formErrors, setFormErrors] = useState({});

  const setVal = (key, val) => setVals(p => ({ ...p, [key]: val }));
  const toggle = key => {
    setVals(p => ({ ...p, [key]: p[key] ? 0 : 1 }));
    setTouched(p => ({ ...p, [key]: true }));
    if (formErrors[key]) setFormErrors(p => { const n={...p}; delete n[key]; return n; });
  };
  // Untuk required bool field: pilih eksplisit Ya(1) atau Tidak(0)
  const selectBool = (key, val) => {
    setVals(p => ({ ...p, [key]: val }));
    setTouched(p => ({ ...p, [key]: true }));
    if (formErrors[key]) setFormErrors(p => { const n={...p}; delete n[key]; return n; });
  };
  const reset  = () => { setVals(buildDefaults()); setError(''); setTouched({}); setFormErrors({}); };

  const totalSelected = Object.values(vals).filter(v => v === 1).length;
  const currentGroup  = GROUPS.find(g => g.id === activeGroup);
  const currentIdx    = GROUPS.findIndex(g => g.id === activeGroup);

  const buildPayload = () => {
    const input = {};
    GROUPS.forEach(g => g.fields.forEach(f => {
      if (f.type === 'bool') {
        // null (belum dipilih) dikirim sebagai 0, tapi sudah divalidasi sebelum submit
        input[f.key] = (vals[f.key] === 1) ? 1 : 0;
      } else {
        input[f.key] = parseFloat(vals[f.key]) || 0;
      }
    }));
    return { input };
  };

  // Validasi field wajib sebelum submit
  const validateRequired = () => {
    const errs = {};
    REQUIRED_FIELDS.forEach(key => {
      const isBool = REQUIRED_BOOL_FIELDS.includes(key);
      if (isBool) {
        // bool wajib: harus pernah disentuh (touched), nilai apapun boleh
        if (!touched[key]) errs[key] = 'Wajib dipilih';
      } else {
        // numerik wajib: nilai tidak boleh 0 atau kosong
        const v = parseFloat(vals[key]);
        if (!v || v <= 0) errs[key] = 'Wajib diisi';
      }
    });
    setFormErrors(errs);
    return Object.keys(errs).length === 0;
  };

  // Cari grup pertama yang punya error, pindah ke sana
  const jumpToFirstError = (errs) => {
    for (const g of GROUPS) {
      if (g.fields.some(f => errs[f.key])) {
        setActive(g.id);
        break;
      }
    }
  };

  const handleDiagnose = async () => {
    const errs = {};
    REQUIRED_FIELDS.forEach(key => {
      const isBool = REQUIRED_BOOL_FIELDS.includes(key);
      if (isBool) {
        // null = belum dipilih sama sekali
        if (vals[key] === null) errs[key] = 'Wajib dipilih (Ya atau Tidak)';
      } else {
        const v = parseFloat(vals[key]);
        if (!v || v <= 0) errs[key] = 'Wajib diisi';
      }
    });
    setFormErrors(errs);
    if (Object.keys(errs).length > 0) {
      jumpToFirstError(errs);
      setError('Lengkapi semua field yang wajib diisi terlebih dahulu (ditandai ★).');
      return;
    }
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}/api/predict`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildPayload()),
      });
      if (!res.ok) throw new Error(`Server error ${res.status}`);
      const data = await res.json();
      go('result', { ...data, input_vals: vals });
    } catch (e) {
      setError(`Gagal menghubungi server: ${e.message}. Pastikan backend Python berjalan di port 5000.`);
    } finally { setLoading(false); }
  };

  const handlePDF = async () => {
    const errs = {};
    REQUIRED_FIELDS.forEach(key => {
      const isBool = REQUIRED_BOOL_FIELDS.includes(key);
      if (isBool) {
        if (vals[key] === null) errs[key] = 'Wajib dipilih (Ya atau Tidak)';
      } else {
        const v = parseFloat(vals[key]);
        if (!v || v <= 0) errs[key] = 'Wajib diisi';
      }
    });
    setFormErrors(errs);
    if (Object.keys(errs).length > 0) {
      jumpToFirstError(errs);
      setError('Lengkapi semua field yang wajib diisi sebelum mengunduh PDF (ditandai ★).');
      return;
    }
    setPdfLoad(true); setError('');
    try {
      const res = await fetch(`${API}/api/predict/pdf`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildPayload()),
      });
      if (!res.ok) throw new Error(`Server error ${res.status}`);
      const blob = await res.blob();
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url;
      a.download = `neurascan_hasil_${Date.now()}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      setError(`Gagal unduh PDF: ${e.message}`);
    } finally { setPdfLoad(false); }
  };

  return (
    <div className="dx-page iso-grid-bg">
      {/* Dekorasi latar belakang subtle */}
      <div className="page-decor" aria-hidden="true">
        <span className="pd-blob pd-1"/>
        <span className="pd-blob pd-2"/>
        <span className="pd-blob pd-3"/>
        <span className="pd-ring pd-r1"/>
        <span className="pd-plus">+</span>
      </div>
      <div className="dx-container">

        {/* Header */}
        <div className="dx-header">
          <span className="dx-chip">Formulir Diagnosis</span>
          <h1>Pilih & Isi Data Klinis Anak</h1>
          <p>
            Sistem menggunakan <strong>100 fitur klinis</strong> yang dibagi dalam 8 kelompok.
            Isi data selengkap mungkin untuk hasil yang lebih akurat.
          </p>
        </div>

        <div className="dx-layout">
          {/* Sidebar */}
          <div className="dx-sidebar">
            <div className="sidebar-label">Kelompok Data</div>
            {GROUPS.map(g => {
              const filled = g.fields.filter(f => {
                if (f.type === 'bool') return vals[f.key] === 1;
                return vals[f.key] !== (f.default ?? 0);
              }).length;
              return (
                <button
                  key={g.id}
                  className={`group-btn ${activeGroup === g.id ? 'active' : ''} ${g.fields.some(f => formErrors[f.key]) ? 'has-error' : ''}`}
                  style={{ '--gc': g.color }}
                  onClick={() => setActive(g.id)}
                >
                  <span className="group-icon">{g.icon}</span>
                  <span className="group-meta">
                    <span className="group-title">{g.title}</span>
                    <span className="group-count">{g.fields.length} fitur</span>
                  </span>
                  {filled > 0 && <span className="group-badge">{filled}</span>}
                </button>
              );
            })}

            <div className="sidebar-summary">
              <div className="sum-label">Gejala Aktif</div>
              <div className="sum-val">{totalSelected}</div>
              <div className="sum-sub">dari 100 fitur</div>
              <div className="sum-bar"><div className="sum-fill" style={{ width: `${(totalSelected/100)*100}%` }}/></div>
            </div>

            <button className="btn-reset-full" onClick={reset}>↺ Reset Semua</button>
          </div>

          {/* Panel */}
          <div className="dx-panel">
            <div className="panel-header" style={{ '--gc': currentGroup.color }}>
              <span className="panel-icon">{currentGroup.icon}</span>
              <div>
                <div className="panel-title">Kelompok {currentGroup.id}: {currentGroup.title}</div>
                <div className="panel-sub">{currentGroup.fields.length} fitur dalam kelompok ini</div>
              </div>
            </div>

            {currentGroup.fields.some(f => REQUIRED_FIELDS.includes(f.key)) && (
              <div style={{padding:'8px 24px 0',display:'flex',alignItems:'center',gap:6}}>
                <span style={{color:'var(--red)',fontSize:'.8rem'}}>★</span>
                <span className="required-info"><span className="req-dot"></span> Field bertanda wajib diisi sebelum diagnosis</span>
              </div>
            )}
            <div className="fields-list">
              {currentGroup.fields.map(f => {
                if (f.type === 'bool') {
                  const isRequired = REQUIRED_BOOL_FIELDS.includes(f.key);
                  const hasErr = !!formErrors[f.key];

                  // Field bool WAJIB → dua tombol Ya / Tidak, null = belum dipilih
                  if (isRequired) {
                    const val = vals[f.key]; // null | 0 | 1
                    return (
                      <div key={f.key} className={`field-yesno ${hasErr ? 'yesno-error' : ''}`}>
                        <div className="yesno-label-row">
                          <span className="yesno-label">
                            <span style={{color:'var(--red)',marginRight:4}}>★</span>
                            {f.label}
                          </span>
                          <span className="req-badge">Wajib</span>
                        </div>
                        <div className="yesno-btns">
                          <button
                            className={`yesno-btn yes ${val === 1 ? 'selected' : ''}`}
                            onClick={() => selectBool(f.key, 1)}
                            type="button"
                          >
                            <svg width="14" height="14" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            Ya
                          </button>
                          <button
                            className={`yesno-btn no ${val === 0 ? 'selected' : ''}`}
                            onClick={() => selectBool(f.key, 0)}
                            type="button"
                          >
                            <svg width="14" height="14" viewBox="0 0 12 12" fill="none"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/></svg>
                            Tidak
                          </button>
                        </div>
                        {hasErr && <div className="field-error-msg">⚠ {formErrors[f.key]}</div>}
                      </div>
                    );
                  }

                  // Field bool biasa → toggle seperti sebelumnya
                  const isOn = vals[f.key] === 1;
                  return (
                    <div key={f.key}>
                      <button
                        className={`field-bool ${isOn ? 'on' : ''}`}
                        style={{ '--gc': currentGroup.color }}
                        onClick={() => toggle(f.key)}
                      >
                        <div className="bool-check">
                          {isOn && <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                        </div>
                        <span className="bool-label">{f.label}</span>
                      </button>
                    </div>
                  );
                }
                return (
                  <div key={f.key} className={`field-num ${REQUIRED_FIELDS.includes(f.key) ? 'is-required' : ''} ${formErrors[f.key] ? 'has-error' : ''}`}>
                    <div className="num-label-row">
                      <label>
                        {REQUIRED_FIELDS.includes(f.key) && <span style={{color:'var(--red)',marginRight:4}}>★</span>}
                        {f.label}
                      </label>
                      <div style={{display:'flex',alignItems:'center',gap:6}}>
                        {REQUIRED_FIELDS.includes(f.key) && <span className="req-badge">Wajib</span>}
                        {f.unit && <span className="num-unit">{f.unit}</span>}
                      </div>
                    </div>
                    <div className="num-input-row">
                      <input
                        type="number"
                        min={f.min} max={f.max} step={f.step}
                        value={vals[f.key]}
                        className={formErrors[f.key] ? 'input-error' : ''}
                        onChange={e => {
                          setVal(f.key, parseFloat(e.target.value) || 0);
                          if (formErrors[f.key]) setFormErrors(p => { const n={...p}; delete n[f.key]; return n; });
                        }}
                      />
                      <input
                        type="range"
                        min={f.min} max={f.max} step={f.step}
                        value={vals[f.key]}
                        onChange={e => setVal(f.key, parseFloat(e.target.value))}
                        className="range-input"
                        style={{ '--gc': currentGroup.color }}
                      />
                    </div>
                    {formErrors[f.key] && <div className="field-error-msg">⚠ {formErrors[f.key]}</div>}
                  </div>
                );
              })}
            </div>

            {/* Navigation */}
            <div className="panel-nav">
              {currentIdx > 0 && (
                <button className="nav-btn" onClick={() => setActive(GROUPS[currentIdx-1].id)}>
                  ← {GROUPS[currentIdx-1].title}
                </button>
              )}
              {currentIdx < GROUPS.length-1 && (
                <button className="nav-btn next" onClick={() => setActive(GROUPS[currentIdx+1].id)}>
                  {GROUPS[currentIdx+1].title} →
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Error */}
        {error && <div className="dx-error"><span>⚠</span> {error}</div>}

        {/* Action row */}
        <div className="dx-actions">
          <div className="action-info">
            <strong>{totalSelected}</strong> gejala aktif dari 100 fitur
          </div>
          <div className="action-btns">
            <button
              className={`btn-pdf ${pdfLoading ? 'loading' : ''}`}
              onClick={handlePDF}
              disabled={pdfLoading || loading}
              title="Unduh laporan PDF langsung"
            >
              {pdfLoading
                ? <><span className="spin"/>Membuat PDF...</>
                : <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"/></svg>Unduh PDF</>
              }
            </button>
            <button
              className={`btn-diagnose ${loading ? 'loading' : ''}`}
              onClick={handleDiagnose}
              disabled={loading || pdfLoading}
            >
              {loading
                ? <><span className="spin"/>Menganalisis...</>
                : <><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>Diagnosa Sekarang</>
              }
            </button>
          </div>
        </div>

        <div className="dx-disclaimer">
          <strong>⚠️ Perhatian:</strong> Sistem ini merupakan alat bantu skrining awal berbasis machine learning.
          Hasil <strong>bukan diagnosis medis resmi</strong>. Selalu konsultasikan kondisi anak kepada dokter spesialis anak atau neurolog.
        </div>

      </div>
    </div>
  );
}
